// extracted by mini-css-extract-plugin
export default {"branchesTable":"ContestTriggerV2Panel_branchesTable__YkaeN"};